import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiArrowRight } from 'react-icons/fi';
import PlaybookLadderChart from './PlaybookLadderChart';
import { playbookTotals, formatRange } from '../../lib/playbookEconomics';
import { trackEvent } from '../../lib/analytics';

/**
 * Versión CORTA de la escalera, para la home y /platform: la gráfica del
 * sumatorio (que es lo que enseña que un playbook se contrata en bloque) y una
 * línea por playbook. Nada más.
 *
 * NO se reutiliza `PlaybooksLadder` aquí a propósito:
 *  - su tarjeta lleva el botón "Usar en la calculadora", que llama a un
 *    `onSelect` cableado al ROICalculator de /playbooks; en la home sería un
 *    botón muerto;
 *  - termina con un enlace al catálogo, absurdo dentro de una pestaña cuya
 *    hermana ES el catálogo;
 *  - despliega las etapas con el nombre de cada proceso, que en esta misma
 *    página ya salen en el panel del catálogo.
 * El detalle completo se queda donde tiene sentido: /playbooks.
 */
const PlaybooksTeaser = ({ playbooks, locale }) => {
   const { t } = useTranslation();

   // Con divisas mezcladas el mensual que se enseña es SOLO el de la divisa
   // principal: si no se avisa, la cifra se lee como si fuera el total.
   const anyMixed = playbooks.some((playbook) => {
      const totals = playbookTotals(playbook.economics);
      return Boolean(totals && totals.mixedCurrency);
   });

   return (
      <>
         <p className="caps__intro">{t('caps_playbooks_intro')}</p>

         {/* Se pinta sola si hay importes mensuales; devuelve null si no los hay,
             y entonces la lista de abajo sigue siendo el contenido del panel. */}
         <PlaybookLadderChart playbooks={playbooks} locale={locale} />

         <ul className="pbt-list">
            {playbooks.map((playbook) => {
               const totals = playbookTotals(playbook.economics);
               const monthly =
                  totals && totals.monthly
                     ? `${formatRange(
                          totals.monthly.min,
                          totals.monthly.max,
                          totals.currency,
                          locale
                       )}${totals.isPartial ? '+' : ''}`
                     : '';
               return (
                  <li className="pbt-row" key={playbook.UUID}>
                     <span className="pbt-row__step">{t('pbl_step', { n: playbook.step })}</span>
                     <span className="pbt-row__title">{playbook.title}</span>
                     <span className="pbt-row__count">
                        {t('pbl_processes', { count: playbook.integrations_count })}
                     </span>
                     {monthly ? (
                        <span className="pbt-row__money">
                           <em>{t('pbl_monthly')}</em> {monthly}
                        </span>
                     ) : null}
                  </li>
               );
            })}
         </ul>

         {/* Si viaja la cifra, viaja el aviso que la sostiene. */}
         <p className="pbt-notice">
            {t('pbl_notice_estimate')}
            {anyMixed ? ` ${t('pbl_notice_mixed')}` : ''}
         </p>

         <div className="pbt-foot">
            <Link
               to="/playbooks"
               className="z-btn z-btn-3"
               onClick={() => trackEvent('Engagement', 'Capabilities to Playbooks', '')}
            >
               {t('caps_playbooks_cta')} <FiArrowRight size={15} />
            </Link>
         </div>
      </>
   );
};

export default PlaybooksTeaser;
